export default {
  'app.setting.pagestyle': '整体风格设置',
  'app.setting.pagestyle.light': '亮色菜单风格',
  'app.setting.pagestyle.dark': '暗色菜单风格',
  'app.setting.pagestyle.realdark': '暗黑模式',
  'app.setting.themecolor': '主题色',
  'app.setting.navigationmode': '导航模式',
  'app.setting.content-width': '内容区域宽度',
  'app.setting.fixedheader': '固定 Header',
  'app.setting.fixedsidebar': '固定侧边栏',
  'app.setting.multitab': '显示页签',
  'app.setting.sidemenu': '侧边菜单布局',
  'app.setting.topmenu': '顶部菜单布局',
  'app.setting.content-width.fixed': 'Fixed',
  'app.setting.content-width.fluid': 'Fluid',
  'app.setting.othersettings': '其他设置',
  'app.setting.weakmode': '色弱模式',
  'app.setting.copy': '拷贝设置',
  'app.setting.loading': '加载主题中',
  'app.setting.copyinfo': '拷贝设置成功 src/config/defaultSettings.js',
  'app.setting.production.hint': '配置栏只在开发环境用于预览，生产环境不会展现，请拷贝后手动修改配置文件',
  'app.setting.themecolor.daybreak': '拂晓蓝',
  'app.setting.themecolor.dust': '薄暮',
  'app.setting.themecolor.volcano': '火山',
  'app.setting.themecolor.sunset': '日暮',
  'app.setting.themecolor.cyan': '明青',
  'app.setting.themecolor.green': '极光绿',
  'app.setting.themecolor.geekblue': '极客蓝',
  'app.setting.themecolor.purple': '酱紫',

  '系统用户': {
    '开始时间': '开始时间',
    '结束时间': '结束时间',
  },

  '被引用次数': '被引用次数',

  '通用': {
    '按钮': {
      '新增': '新增',
      '确定': '确定',
      '审核': '审核',
      '修改': '修改',
      '复制': '复制',
      '删除': '删除',
      '解绑': '解绑',
      '关闭': '关闭',
      '导出': '导出',
      '选中导出': '选中导出',
      '导入': '导入',
      '查询': '查询',
      '重置': '重置',
      '详情': '详情',
      '上传': '上传',
      '展开': '展开',
      '收起': '收起',
      '更多': '更多',
      '保存': '保存',
      '取消': '取消',
      '保存并离开': '保存并离开',
      '不保存': '不保存',
      '翻译': '翻译',
      '刷新缓存': '刷新缓存',
      '详情及审核': '详情及审核',
      '客服': '客服',
      '平台客服': '平台客服',
    },
    '输入':{
      '请输入':'请输入 ',
      '请选择':'请选择 ',
    },
    '文本': {
      '是': '是',
      '否': '否',
      '启用': '启用',
      '禁用': '禁用',
      '操作': '操作',
      '操作成功': '操作成功',
      '添加': '添加',
      '创建时间': '创建时间',
      '排序': '排序',
      '修改': '修改',
      '详情': '详情',
      '确认删除所选中数据': '确认删除所选中数据?',
      '删除成功': '删除成功',
      '确认取消': '确认取消?',
      '取消成功': '取消成功',
      '新增成功': '新增成功',
      '修改成功': '修改成功',
      '上传成功': '上传成功',
      '导出成功': '导出成功',
      '共': '共',
      '条': '条',
      '默认': '默认',
      '中等': '中等',
      '紧凑': '紧凑',
      '列展示排序': '列展示排序',
      '列排序需拖动名称': '列排序需拖动名称',
      '不能为空': '不能为空',
      '格式错误': '格式错误',
      '不能小于0': '不能小于0',
      '多语言配置': '多语言配置',
      '语言': '语言',
      '根节点': '根节点',
      '创建开始时间': '创建开始时间',
      '创建结束时间': '创建结束时间',
      '选择商品': '选择商品',
      '详情及审核': '详情及审核',
      '确认核销': '确认核销?',
      '核销成功': '核销成功',
      '确认提交': '确认提交?',
      '是否确认导出': '是否确认导出?',
      '离开确认': '离开确认',
      '未保存离开提示': '当前页面内容尚未保存，是否保存后离开？',
      '此操作将导出当前条件下所有数据而非选中数据': '此操作将导出当前条件下所有数据而非选中数据',
      '此操作将导出选中数据': '此操作将导出选中数据',
    },
  },
  '广告': {
    '位置': '位置',
    '跳转类型': '跳转类型',
    '广告名称': '广告名称',
    '开始时间': '开始时间',
    '结束时间': '结束时间',
    '选择申请': '选择申请',
    '外链': '外链',
    '内容详情': '内容详情',
    '是否隐藏': '是否隐藏',
    '展示时长': '展示时长',
    '展示次数': '展示次数',
    '点击次数': '点击次数',
    '跳转次数': '跳转次数',
    '封面图': '封面图',
    '详情图': '详情图',
    '创建时间': '创建时间',
    '选择上门服务': '选择上门服务',
    '选择上门服务公告': '选择上门服务公告',
    '选择商城头条': '选择商城头条',
    '选择云种植公告': '选择云种植公告',
    '选择店铺': '选择店铺',
    '店铺名称': '店铺名称',
  },

  '商品分类': {
    '商品分类': '商品分类',
    '分类名称': '分类名称',
    '分类图片': '分类图片',
    '上级分类': '上级分类',
    '分类等级': '分类等级',
    '是否显示': '是否显示',
    '是否首页展示': '是否首页展示',
    '是否参与筛选': '是否参与筛选',
    '创建时间': '创建时间',
    '分类类型': '分类类型',
    '国内': '国内',
    '跨境': '跨境',
  },
  '商品标签':{
    '标签名称':'标签名称',
    '图标':'图标',
    '颜色':'颜色',
    '状态':'状态',
    '创建时间':'创建时间',
    '更新时间':'更新时间',
    '备注':'备注',
  },
  '商品': {
    '套餐': '套餐',
    '标签': '标签',
    '备注': '备注',
    '售卖区域': '售卖区域',
    '批量上架': '批量上架',
    '批量下架': '批量下架',
    '批量复制': '批量复制',
    '确认复制': '确认复制?',
    '复制成功': '复制成功',
    '选择明星': '选择明星',
    '选择运费模板': '选择运费模板',
    '基础信息': '基础信息',
    '标签信息': '标签信息',
    '规格信息': '规格信息',
    '详情信息': '详情信息',
    '上架成功': '上架成功',
    '下架成功': '下架成功',
    '确认上架': '确认上架?',
    '确认下架': '确认下架?',
    '确认保存商品信息': '确认要保存该商品信息吗?',
    '添加规格': '添加规格',
    '修改规格': '修改规格',
    '商品类型': '商品类型',
    '商品': '商品',
    '明星': '明星',
    '限购数': '限购数',
    '售卖开始时间': '售卖开始时间',
    '售卖结束时间': '售卖结束时间',
    '是否多规格': '是否多规格',
    '是否允许合并购买': '是否允许合并购买',
    '商品颜色': '商品颜色',
    '商品详情': '商品详情',
    '温馨提示': '温馨提示',
    '市场价': '市场价(划线价格)',
    '成本价': '成本价',
    '代币价': '代币价',
    '虚拟销量': '虚拟销量',
    '是否展示销量': '是否展示销量',
    '商品价': '商品价',
    '商品编号': '商品编号',
    '店铺名称': '店铺名称',
    'SKU编号': 'SKU编号',
    '商品条码': '商品条码',
    'SKU名字': '规格',
    '售卖店铺': '售卖店铺',
    '规格名称': '规格名称',
    '商品名称': '商品名称',
    '商品重量': '商品重量',
    '包装单位': '包装单位',
    '商品主图': '商品主图',
    '商品视频': '商品视频',
    '商品轮播图': '商品轮播图',
    '商品分类': '商品分类',
    '店铺商品分类': '店铺商品分类',
    '跨境商品分类': '跨境商品分类',
    '国家': '国家',
    '商品关键词': '商品关键词',
    '品牌': '品牌',
    '运费模板': '运费模板',
    '商品价格': '销售价',
    '自购返金额': '自购返金额',
    '活动价格': '活动价格',
    '代币价格': '代币价格',
    '秒杀价格': '秒杀价格',
    '团购价格': '团购价格',
    '会员价格': '会员价格',
    '限购数量': '限购数量',
    '商品库存': '商品库存',
    '预警库存': '预警库存',
    '商品状态': '商品状态',
    '实际销量': '实际销量',
    '售卖范围': '售卖范围',
    '是否推荐': '是否推荐',
    '是否新品': '是否新品',
    '是否甄选': '是否甄选',
    '是否样品': '是否样品',
    '是否日历展示': '是否日历展示',
    '是否精品': '是否精品',
    '是否免费领': '是否免费领',
    '是否限购': '是否限购',
    '是否爆款': '是否爆款',
    '售后方式': '售后方式',
    '创建时间': '创建时间',
    '规格': {
      '添加规格值': '添加规格值',
      '规格名称': '规格名称',
      '规格值': '规格值',
      '是否可见': '是否可见',
      '规格图片': '规格图片',
      '是否有规格图片': '是否有规格图片',
    },
    'sku': {
      '名称': '名称',
      '编码': '编号',
      '价格': '价格',
      '活动价格': '活动价格',
      '库存': '库存',
      '重量': '重量',
      '图片': '图片',
    },
  },
  '品牌': {
    '品牌名称': '品牌名称',
    '品牌备注': '品牌备注',
    '品牌首字母': '品牌首字母',
    'logo': 'logo',
    '创建时间': '创建时间',
  },
  '明星分类': {
    '分类名称': '分类名称',
    '是否显示': '是否显示',
    '创建时间': '创建时间',
    '备注': '备注',
  },
  '明星': {
    '明星名字': '明星名字',
    '明星分类': '明星分类',
    '明星照片': '明星照片',
    '背景图': '背景图',
    '网址': '网址',
    '状态': '状态',
    '基础粉丝数': '基础粉丝数',
    '关注数': '关注数',
    '明星介绍': '明星介绍',
    '创建时间': '创建时间',
    '备注': '备注',
  },
  '明星俱乐部': {
    '俱乐部名字': '俱乐部名字',
    '商品数': '商品数',
    '创建时间': '创建时间',
    '备注': '备注',
  },

  '活动分类':{
    '分类名称':'分类名称',
    '状态':'状态',
    '排序':'排序',
    '创建者':'创建者',
    '创建时间':'创建时间',
    '修改人':'修改人',
    '更新时间':'更新时间',
    '备注':'备注',
    '首页图片':'首页图片',
  },
  '活动记录': {
    '活动编号':'活动编号',
    '商品最大购买数量':'商品最大购买数量',
    '排行':'排行',
    '选择活动':'选择活动',
    '是否上架':'是否上架',
    '活动类型':'活动类型',
    '活动名称':'活动名称',
    '开始时间':'开始时间',
    '结束时间':'结束时间',
    '活动封面图':'活动封面图',
    '分享海报图':'分享海报图',
    '分享文案':'分享文案',
    '限制会员等级':'限制会员等级',
    '最多参与次数':'最多参与次数',
    '活动详情':'活动详情',
    '状态':'状态',
    '是否展示到日历':'是否展示到日历',

    '创建时间':'创建时间',
    '活动参与区域':'活动参与区域'
  },
  '运费模板': {
    '计费方式':'计费方式'
  },
  '收货地址': {
    '应援地址':'应援地址',
    '收货区域':'收货区域',
    '收货人手机号':'收货人手机号',

  },
  '广告投放审核': {
    '联系电话': '联系电话',
    '广告名称': '广告名称',
    '广告简介': '广告简介',
    '广告活动开始时间': '开始时间',
    '广告活动结束时间': '结束时间',
    '审核状态': '审核状态',
    '审核时间': '审核时间',
    '姓名': '姓名',
    '创建时间':'创建时间',
    '原因': '原因',
    '是否通过': '是否通过',

  },
  '订单取消原因': {
    '名称':'名称',
    '类型':'类型',
    '用途类型':'用途类型',
    '创建时间':'创建时间',
    '是否显示':'是否显示',
  },

  '等级设置': {
    '会员等级名称': '等级名称',
    '会员等级卡片名称': '卡片名称',
    '会员等级':'会员等级',
    '升级所需经验':'升级所需经验',
    '等级图片': '等级图片',
    '等级图标': '等级图标',
    '会员等级排序': '会员等级排序',
    '升级所需代币': '升级所需代币',
  },
  '商品足迹': {
    '商品名称': '商品名称',
    '商品主图': '商品主图',
    '排序': '排序',
    '搜索次数': '搜索次数',
    '创建时间': '创建时间',
  },
  '订单发货记录': {
    '发货方式': '发货方式',
    '发货人手机号': '发货人手机号',
    '发货时间': '发货时间',
    '发货记录编号': '发货记录编号',
    '发货开始时间': '发货开始时间',
    '发货结束时间': '发货结束时间',

  },
  '举报':{
  '举报内容':'举报内容',
    '创建时间':'创建时间',
    '人员信息':'人员信息'
},

  '销售订单': {
    '全部订单': '全部订单',
    '此操作将导出当所有待发货订单而非选中数据':'此操作将导出当所有待发货订单而非选中数据',
    '导出待发货':'导出待发货',
    '导入发货单':'导入发货单',
    '接单':'接单',
    '接单成功':'接单成功',
    '物流公司':'物流公司',
    '物流单号':'物流单号',
    '物流详情':'物流详情',
    '寄件人手机号':'寄件人手机号',
    '订单编号':'订单编号',
    '订单类型':'订单类型',
    '订单来源':'订单来源',
    '直播间名称':'直播间名称',
    '普通购买':'普通购买',
    '直播间购买':'直播间购买',
    '平台币抵扣':'平台币抵扣',
    '代币抵扣':'代币抵扣',
    '订单数量':'订单数量',
    '订单信息':'订单信息',
    '订单详情':'订单详情',
    '三方订单号':'三方订单号',
    '买家名称':'买家名称',
    '买家信息':'买家信息',
    '手机号或邮箱':'手机号或邮箱',
    '订单状态':'订单状态',
    '下单时间':'下单时间',
    '配送信息':'配送信息',
    '配送方式':'配送方式',
    '下单开始时间':'下单开始时间',
    '下单结束时间':'下单结束时间',
    '支付方式':'支付方式',
    '支付时间':'支付时间',
    '退款状态':'退款状态',
    '商品数量':'商品数量',
    '商品金额':'商品金额',
    '商品实付金额':'商品实付金额',
    '优惠金额':'优惠金额',
    '平台抽成':'平台抽成',
    '订单金额':'订单金额',
    '运费金额':'运费金额',
    '运费实付':'运费实付',
    '平台币':'平台币',
    '用户备注':'用户备注',
    '商品信息':'商品信息',
    '活动信息':'活动信息',
    '收货地址信息':'收货地址信息',
    '实付单价':'实付单价',
    '数量':'数量',
    '收货人姓名':'收货人姓名',
    '核销码':'核销码',
    '性别':'性别',
    '手机号':'手机号',
    '邮箱':'邮箱',
    'ID/邀请码':'ID/邀请码',
    '地址类型':'地址类型',
    '地区':'地区',
    '详细地址':'详细地址',
    '发货':'发货',
    '核销':'核销',
    '发货成功':'发货成功',
    '取消订单':'取消订单',
    '核销订单':'核销订单',
    '发货备注':'发货备注',
    '核销备注':'核销备注',
    '店铺名称':'店铺名称',

    '订单原价':'订单原价',
    '实付金额':'实付金额',
    '运费':'运费',
    '是否首单':'是否首单',
    '是否催发货':'是否催发货',

    '预约日期':'预约日期',
    '预约开始时间':'开始时间',
    '预约结束时间':'结束时间',
    '是否需要预约':'是否需预约',
    '售卖结束时间':'售卖结束时间',
    '核销码':'核销码',
    '套餐信息':'套餐信息',
    '人员信息':'人员信息',

  },
  '售后订单': {
    '原订单编号': '原订单编号',
    '售后单编号': '售后单编号',
    '售后类型': '售后类型',
    '售后状态': '售后状态',
    '售后凭证': '售后凭证',
    '购买数量': '购买数量',
    '售后数量': '售后数量',
    '申请开始时间':'申请开始时间',
    '申请结束时间':'申请结束时间',
    '退款金额': '退款金额',
    '申请时间': '申请时间',
    '售后原因': '售后原因',
    '寄回备注': '寄回备注',
    '寄回凭证': '寄回凭证',
    '售后信息': '售后信息',
    '原订单信息': '原订单信息',
    '订单详情':'订单详情',
    '售后详情':'售后详情',
    '售后商品':'售后商品',
    '备注':'备注',
    '审核':'审核',
    '是否同意':'是否同意',
    '拒绝原因':'拒绝原因',
    '审核成功':'审核成功',
    '退款': '退款',
    '是否确认退款': '是否确认退款',
    '退款成功': '退款成功',
    '收货地址':'收货地址',


  },

  '用户': {
    '发送消息':'发送消息',
    '手机号':'手机号',
    '联系方式':'联系方式',
    '用户等级':'等级',
    '邮箱':'邮箱',
    '昵称':'昵称',
    '微信':'微信',
    '代币':'代币',
    '角色类型':'角色类型',
    '真实姓名':'真实姓名',
    '身份证':'身份证',
    '头像':'头像',
    '审核状态':'审核状态',
    '性别':'性别',
    '生日':'生日',
    '钱包':'钱包',
    '员工':'员工',
    '营养师':'营养师',
    '用户':'用户',
    '邀请码':'邀请码',
    '注册时间':'注册时间',
    '开始时间':'开始时间',
    '结束时间':'结束时间',
    '用户状态':'用户状态',
    '当日活跃时长':'当日活跃时长(分钟)',
    '解封时间':'解封时间',
    '健康状况':'健康状况',
    '婚姻状况':'婚姻状况',
    '兴趣爱好':'兴趣爱好',
    '职业':'职业',
    '保密':'保密',
    '男':'男',
    '女':'女',
    '用户个性签名':'用户个性签名',
    '备注':'备注',
    '青少年模式':'青少年模式',
    '已开启':'已开启',
    '未开启':'未开启',
    '关闭青少年模式':'关闭青少年模式',
    '确认关闭青少年模式':'确认关闭该用户的青少年模式？',
    '关闭青少年模式成功':'关闭青少年模式成功',
  },
  '用户代币变动记录':{
    '订单编号':'订单编号',
    '备注':'备注',
    '变动的代币数':'变动的代币数',
    '变动前剩余代币':'变动前剩余代币',
    '变动后剩余代币':'变动后剩余代币',
  },

  "直播间连麦":{
    '直播间创建人': '直播间创建人',
    '连麦类型':'连麦类型',
    '直播间':'直播间',
    '连麦状态':'连麦状态',
    '连麦静音状态':'连麦静音状态',
    '摄像头状态':'摄像头状态',
    '管理员连麦状态':'管理员连麦状态',
    '创建时间':'创建时间'
  },
  '用户搜索记录': {
    '类型':'类型',
    '搜索内容':'搜索内容',
    '搜索次数':'搜索次数',
    '创建时间':'创建时间',
  },

  '用户注销': {
    '注销原因':'注销原因',
    '审核状态':'审核状态',
    '审核失败原因':'审核失败原因',
    '审核人':'审核人',
    '审核时间':'审核时间',
    '注销时间':'注销时间',
  },

  '意见反馈': {
    '用户':'用户',
    '处理状态':'处理状态',
    '备注':'备注',
    '处理':'处理',
    '反馈图片':'反馈图片',
    '联系方式':'联系方式',
    '反馈类型':'反馈类型',
    '反馈内容':'反馈内容',
    '处理结果':'处理结果',
    '创建时间':'创建时间',
  },

  '物流公司信息': {
    '编号': '编号',
    '公司名称': '公司名称',
    '公司编码': '公司编码',
    '公司类型': '公司类型',
    '公司logo': '公司logo',
    '是否选用': '是否选用',
    '排序': '排序',
    '备注': '备注',

  },
  '报表': {
    '商品': {
      '订单开始时间': '订单开始时间',
      '订单结束时间': '订单结束时间',
      '销售占比': '销售占比',
      '退款占比': '退款占比',
      '点击量': '点击量',
      '收藏量': '收藏量',
      '订单量': '订单量',
      '商品销量': '商品销量',
      '加购量': '加购量',
      '商品销售额': '商品销售额',
      '订单销售金额': '订单销售金额',
      '销售金额': '销售金额',
      '退款金额': '退款金额',
      '退款单数': '退款单数',
      '退款量': '退款量',
    },
    '用户': {
      '注册开始时间': '注册开始时间',
      '注册结束时间': '注册结束时间',
      '支付金额': '支付金额',
      '最后下单时间': '最后下单时间',
      '购买商品量': '购买商品量',
    },
  },


  '商品对账单': {
    '账单日期': '账单日期',
    '账单月份': '账单月份',

  },
  '交易单':{
    '交易单号':'交易单号',
    '订单编号':'订单编号',
    '订单类型':'订单类型',
    'ip':'ip',
    '支付方式':'支付方式',
    '交易类型':'交易类型',
    '支付金额':'支付金额',
    '账期金额':'账期金额',
    '手续费':'手续费',
    '支付信息':'支付信息',
    '三方订单号':'三方订单号',
    '三方支付流水号':'三方支付流水号',
    '支付状态': '支付状态',
    '交易完成时间':'交易完成时间',
    '创建时间':'创建时间',
    '过期时间':'过期时间',
    '备注':'备注',
  },
  '常见问题':{
    '常见问题标题':'常见问题标题',
    '常见问题简述':'常见问题简述',
    '问题分类':'问题分类',
    '常见问题内容':'常见问题内容',
    '内容类型':'内容类型',
    '富文本':'富文本',
    'PDF':'PDF',
    '显示顺序':'显示顺序',
    '状态':'状态',
    '备注':'备注',
    '创建人':'创建人',
    '插入时间':'插入时间',
    '修改人':'修改人',
    '修改时间':'修改时间',
    '版本号':'版本号',
  },
  '常见问题分类':{
    '主图':'主图',
    '标题':'标题',
    '显示顺序':'显示顺序',
    '备注':'备注',
    '创建人':'创建人',
    '插入时间':'插入时间',
    '修改人':'修改人',
    '修改时间':'修改时间',
    '版本号':'版本号',
  },
  '店铺分类': {
    '店铺分类': '店铺分类',
    '分类名称': '分类名称',
    '分类图片':'分类图片',
    '上级分类': '上级分类',
    '分类等级': '分类等级',
    '是否显示': '是否显示',
    '是否首页展示': '是否首页展示',
    '是否参与筛选': '是否参与筛选',
    '创建时间': '创建时间',
  },
  '入驻时长': {
    '入驻时长（年）': '入驻时长（年）',
    '入驻时长已存在': '入驻时长已存在，不能重复添加',
    '分类名称': '分类名称',
    '分类图片':'分类图片',
    '上级分类': '上级分类',
    '分类等级': '分类等级',
    '是否显示': '是否显示',
    '是否首页展示': '是否首页展示',
    '是否参与筛选': '是否参与筛选',
    '创建时间': '创建时间',
  },
  '主营行业': {
    '分类名称': '行业名称',
    '创建时间': '创建时间',
  },
  '店铺': {
    '店铺名称': '店铺名称',
    '店铺logo': 'logo',
    '店铺背景图':'背景图',
    '客服电话': '客服电话',
    '入驻时长': '入驻时长(年)',
    '入驻类型': '入驻类型',
    '店铺类型': '店铺类型',
    '是否推荐': '是否推荐',
    '推荐时间': '推荐时间',
    '账户余额': '账户余额',
    '已结算金额': '已结算金额',
    '平台抽成比例': '平台抽成比例%',
    '营业执照号': '营业执照号',
    '店铺状态': '店铺状态',
    '审核状态': '审核状态',
    '钱包开通状态': '钱包开通状态',
    '关键词': '关键词',
    '营业时间': '营业时间',
    '绑定时长': '绑定时长',
    '店铺分类': '店铺分类',
    '基础信息': '基础信息',
    '主营行业': '主营行业',
    '店铺等级': '店铺等级',
    '地址信息': '地址信息',
    '店铺所在省份': '省份',
    '店铺所在城市': '城市',
    '店铺所在县': '县',
    '经度': '经度',
    '纬度': '纬度',
    '详细地区': '详细地址',
    '店铺简介': '店铺简介',
    '公司申请类型': '申请类型',
    '店铺时间': '创建时间',
    '入驻资料': '入驻资料',
    '法人姓名': '法人姓名',
    '法人手机号': '法人手机号',
    '法人邮箱': '法人邮箱',
    '法人身份证号': '法人身份证号',
    '身份证人像面': '身份证人像面',
    '身份证国徽面': '身份证国徽面',
    '营业执照': '营业执照',
    '真实姓名': '真实姓名',
    '结算账户': '结算账户',
    '银行预留手机号': '银行预留手机号',
    '结算银行开户名': '银行开户名',
    '结算开户银行支行名称': '开户银行支行名称',
    '开户行所在省份': '开户行所在省份',
    '结算开户银行所在省': '结算开户银行所在省',
    '开户行所在城市': '开户行所在城市',
    '自提时间': '自提时间',
    '结算开户银行所在地': '开户银行所在地',
    '审核信息': '审核信息',
    '保证金信息': '保证金信息',
    '保证金': '保证金',
    '打款备注': '打款备注',
    '打款截图': '打款截图',
    '打款截图': '打款截图',
    '店铺状态是否开启': '店铺状态是否开启',
  },
  '账户类型': {
    '账户类型名称': '账户类型名称',
    '创建时间': '创建时间',
  },
  '店铺标签': {
    '标签名称': '标签名称',
    '创建时间': '创建时间',
  },
  '店铺等级': {
    '等级名称': '等级名称',
    '等级名称(英文)': '等级名称(英文)',
    '等级名称(繁体)': '等级名称(繁体)',
    '等级级别': '等级级别',
    '服务费': '服务费(元/年)',
    '平台抽成比例': '平台抽成比例',
    '可发布最大商品数量': '可发布最大商品数量',
    '创建时间': '创建时间',
  },
  '线下店铺套餐内容': {
    '备注': '套餐标题',
    '套餐标题': '套餐标题',
    '有效期': '有效期说明',
    '使用时间': '使用时间说明',
    '使用规则': '使用规则说明',
    '套餐logo': '内容图片',
    '创建时间': '创建时间',
    '是否需要预约': '是否需要预约',
    '是否需要添加人员': '是否需要添加人员',
  },
  '线下店铺套餐详情': {
    '商品套餐': '商品套餐',
    '套餐主标题': '套餐主标题',
    '套餐副标题': '套餐副标题',
    '套餐详情价格': '套餐价格',
    '排序': '排序',
    '创建时间': '创建时间',
    '套餐名称': '套餐名称',
    '手机号': '手机号',
    '姓名': '姓名',
  },
  '线下报名':{
      '活动id':'活动id',
      '用户姓名':'用户姓名',
      '手机号':'手机号',
      '支付金额':'支付金额',
      '1微信支付 2支付宝':'1微信支付 2支付宝',
      '0未支付，1支付成功，2支付失败':'0未支付，1支付成功，2支付失败',
      '插入时间':'插入时间',
      '修改时间':'修改时间',
      '创建人':'创建人',
      '活动名称':'活动名称',
      '修改人':'修改人',
      '报名时间':'报名时间',
  },
  '优惠券类型':{
    '店铺ID': '店铺ID',
    '发放店铺': '发放店铺',
    '优惠券名称': '优惠券名称',
    '发放面额': '发放面额',
    '发放数量': '发放数量',
    '每人最大领取个数 0无限制':'每人最大领取个数 0无限制',
    '满多少元使用':'满多少元使用',
    '领取人会员等级':'领取人会员等级',
    '使用范围':'使用范围',
    '业务ID，与type合并使用，如type为1，全场可用，为2，分类id，以此类推':'业务ID，与type合并使用，如type为1，全场可用，为2，分类id，以此类推',
    '有效日期开始时间':'有效开始时间',
    '有效日期结束时间':'有效结束时间',
    '优惠券状态':'状态',
    '是否允许首页显示0不显示1显示':'是否允许首页显示0不显示1显示',
    '优惠券详细信息':'优惠券详细信息',
    '是否新人优惠券':'是否新人优惠券',
    '创建时间':'创建时间',
    '修改时间':'修改时间',
    '创建人':'创建人',
    '修改人':'修改人',
    '逻辑删除标记 1:删除,0:未删除':'逻辑删除标记 1:删除,0:未删除',
    '备注':'备注',
    '店铺':'店铺',
    '结束时间不能早于开始时间':'结束时间不能早于开始时间',
    '使用场景':'使用场景',
    '商城':'商城',
    '上门服务':'上门服务',
    '领取数量':'领取数量',
    '已使用数量':'已使用数量',
    '领取明细':'领取明细',
    '领取人':'领取人',
    '领取人搜索提示':'可搜索昵称或手机号',
    '昵称':'昵称',
    '手机号':'手机号',
    '领取时间':'领取时间',
    '使用时间':'使用时间',
    '使用状态':'使用状态',
  },
  '秒杀时间轴':{
    '主键id':'主键id',
    '秒杀开始时间':'秒杀开始时间',
    '秒杀结束时间':'秒杀结束时间',
    '是否显示 0：否 1：是':'是否显示 0：否 1：是',
    '活动名称':'活动名称',
    '创建时间':'创建时间',
    '修改时间':'修改时间',
    '创建人':'创建人',
    '修改人':'修改人',
    '逻辑删除标记 1:删除,0:未删除':'逻辑删除标记 1:删除,0:未删除',
    '备注':'备注',
  },
  '秒杀库存':{
    '主键id':'主键id',
    '时间轴id':'时间轴',
    '商品id':'商品id',
    '商品名称':'商品名称',
    '秒杀价格':'秒杀价格',
    '商品现价':'商品现价',
    '已经秒杀数量':'已经秒杀数量',
    '商品图片':'商品图片',
    '秒杀商品库存':'秒杀商品库存',
    '店铺id':'店铺id',
    '店铺名字':'店铺名字',
    '状态':'状态',
    '秒杀是否完成0未完成 1已抢完':'秒杀是否完成0未完成 1已抢完',
    '拒绝原因':'审核意见',
    '秒杀开始时间':'秒杀开始时间',
    '秒杀场次':'秒杀场次',
    '秒杀结束时间':'秒杀结束时间',
    '最大购买数量':'最大购买数量',
    '创建时间':'创建时间',
    '修改时间':'修改时间',
    '创建人':'创建人',
    '修改人':'修改人',
    '逻辑删除标记 1:删除,0:未删除':'逻辑删除标记 1:删除,0:未删除',
    '备注':'备注',
  },
  '商家退货地址':{
    '商家退货地址id':'商家退货地址id',
    '店铺id':'店铺id',
    '收货人名字':'收货人名字',
    '收货人手机号码':'收货人手机号码',
    '收货人座机':'收货人座机',
    '邮政编码':'邮政编码',
    '省id':'省id',
    '省':'省',
    '城市id':'城市id',
    '城市':'城市',
    '区id':'区id',
    '区':'区',
    '具体地址':'具体地址',
    '默认地址':'是否默认',
    '状态':'是否可用',
    '更新时间':'更新时间',
    '创建时间':'创建时间',
  },
  '用户标签':{
    '标签id':'标签id',
    '标签名称':'标签名称',
    '创建时间':'创建时间',
    '修改时间':'修改时间',
    '创建人':'创建人',
    '修改人':'修改人',
    '备注':'备注',
  },
'系统日志':{
  '接口名称':'接口名称',
    '操作人员':'操作人员',
    '接口地址':'接口地址',
    '请求入参':'请求入参',
    '接口出参':'接口出参'
},
  '拼团活动商品':{
    '主键id':'主键id',
    '店铺id':'店铺id',
    '商品id':'商品id',
    '活动名称':'活动名称',
    '拼团有效期':'拼团有效期(小时)',
    '发起拼团额外付的钱':'发起拼团额外付的钱',
    '成团人数':'成团人数',
    '商品名称':'商品名称',
    '拼团价格':'拼团价格',
    '原价':'原价',
    '商品图片':'商品图片',
    '状态': '状态',
    '拒绝原因':'拒绝原因',
    '拼团开始时间':'拼团开始时间',
    '拼团结束时间':'拼团结束时间',
    '最大购买数量':'最大购买数量',
    '完成拼团数量':'完成拼团数量',
    '总团数量':'总团数量',
    '创建者':'创建者',
    '创建时间':'创建时间',
    '修改人':'修改人',
    '更新时间':'更新时间',
    '逻辑删除标记':'逻辑删除标记',
    '租户ID':'租户ID',
    '备注':'备注',
    '版本号':'版本号',
    'SKU拼团价格设置':'SKU拼团价格设置',
    'SKU名称':'SKU名称',
    'SKU图片':'SKU图片',
    '库存':'库存',
  },
  '秒杀库存':{
    'id':'id',
    '时间轴id':'时间轴id',
    '商品id':'商品id',
    '商品名称':'商品名称',
    '秒杀价格':'秒杀价格',
    '商品现价':'商品现价',
    '已经秒杀数量':'已经秒杀数量',
    '商品图片':'商品图片',
    '秒杀商品库存':'秒杀商品库存',
    '店铺id':'店铺id',
    '店铺名字':'店铺名字',
    '状态':'状态',
    '秒杀是否完成':'秒杀是否完成',
    '拒绝原因':'拒绝原因',
    '秒杀开始时间':'秒杀开始时间',
    '秒杀结束时间':'秒杀结束时间',
    '最大购买数量':'最大购买数量',
    '创建时间':'创建时间',
    '修改时间':'修改时间',
    '创建人':'创建人',
    '修改人':'修改人',
    '备注':'备注',
    'SKU秒杀价格设置':'SKU秒杀价格设置',
    'SKU名称':'SKU名称',
    'SKU图片':'SKU图片',
    '原价':'原价',
    '库存':'库存',
  },
  '砍价活动配置':{
    'id':'id',
    '店铺id':'店铺id',
    '活动名称':'活动名称',
    '活动开始时间':'活动开始时间',
    '活动结束时间':'活动结束时间',
    '商品id':'商品id',
    '商品图片':'商品图片',
    '商品名称':'商品名称',
    '商品原价':'商品原价',
    '审核状态':'审核状态',
    '审核意见':'审核意见',
    '多少人参与砍价即可成功':'多少人参与砍价即可成功',
    '砍价活动价格':'砍价活动价格',
    '该活动完成砍价数量':'该活动完成砍价数量',
    '砍价有效期':'砍价有效期',
    '创建者':'创建者',
    '创建时间':'创建时间',
    '修改人':'修改人',
    '更新时间':'更新时间',
    '逻辑删除标记':'逻辑删除标记',
    '租户ID':'租户ID',
    '备注':'备注',
    '版本号':'版本号',
    '活动开始时间不能早于当前时间':'活动开始时间不能早于当前时间',
    '活动结束时间不能早于当前时间':'活动结束时间不能早于当前时间',
    '活动结束时间不能早于开始时间':'活动结束时间不能早于开始时间',
  },
  '用户提现':{
    '主键id':'主键id',
    '未审核':'未审核',
    '审核未通过':'审核未通过',
    '审核已通过':'审核已通过',
    '支付宝':'支付宝',
    '微信':'微信',
    '银行卡':'银行卡',
    '店铺ID':'店铺ID',
    '店铺名称' :'店铺名称',
    '提现金额':'提现金额',
    '可提现金额':'可提现金额',
    '提现状态':'提现状态',
    '提现账号':'提现账号',
    '提现账号姓名':'提现账号姓名',
    '提现手续费':'提现手续费',
    '提现方式':'提现方式',
    '1：普通用户提现 2：店铺提现4：直播提现5：承兑商提现':'1：普通用户提现 2：店铺提现4：直播提现5：承兑商提现 ',
    '第三方订单号(微信或支付的交易单号)':'第三方订单号(微信或支付的交易单号)',
    '失败原因':'失败原因',
    '审核意见':'审核意见',
    '创建时间':'创建时间',
    '修改时间':'修改时间',
    '创建人':'创建人',
    '修改人':'修改人',
    '逻辑删除标记 1:删除,0:未删除':'逻辑删除标记 1:删除,0:未删除',
    '备注':'备注',
  },
  '预售活动商品配置':{
    'id':'id',
    '店铺id':'店铺id',
    '活动名称':'活动名称',
    '活动开始时间':'活动开始时间',
    '活动结束时间':'活动结束时间',
    '商品id':'商品id',
    '商品名称':'商品名称',
    '商品图片':'商品图片',
    '商品原价':'商品原价',
    '预售商品售卖价格':'预售商品售卖价格',
    '支付定金价格':'支付定金价格',
    '支付尾款价格(预售商品售卖价格-支付定金价格)':'支付尾款价格(预售商品售卖价格-支付定金价格)',
    '审核状态  1:待审核 2:审核未通过 3:审核通过 4:活动已结束（活动已结束后就不能再开始啦需要重新添加活动、商品下架后活动也会结束）':'审核状态  1:待审核 2:审核未通过 3:审核通过 4:活动已结束（活动已结束后就不能再开始啦需要重新添加活动、商品下架后活动也会结束）',
    '审核意见':'审核意见',
    '总完成数量':'总完成数量',
    '尾款付款开始时间':'尾款付款开始时间',
    '创建者':'创建者',
    '创建时间':'创建时间',
    '修改人':'修改人',
    '更新时间':'更新时间',
    '逻辑删除标记':'逻辑删除标记',
    '租户ID，外键{tenant.id}':'租户ID，外键{tenant.id}',
    '备注':'备注',
    '版本号':'版本号',
    '流程说明':'流程说明',
    'SKU预售价格设置':'SKU预售价格设置',
    'SKU名称':'SKU名称',
    'SKU图片':'SKU图片',
    '原价':'原价',
    '库存':'库存',
    '预售价格':'预售价格',
    '活动开始时间不能早于当前时间':'活动开始时间不能早于当前时间',
    '活动结束时间不能早于当前时间':'活动结束时间不能早于当前时间',
    '活动结束时间不能早于开始时间':'活动结束时间不能早于开始时间',
    '尾款付款开始时间不能早于当前时间':'尾款付款开始时间不能早于当前时间',
  },
  '云种植公告': {
    '公告标题': '公告标题',
    '封面图': '封面图',
    '简介': '简介',
    '公告时间': '公告时间',
    '内容': '内容',
    '状态': '状态',
    '排序': '排序',
    '排序提示': '数字越大越靠前',
    '备注': '备注',
    '创建时间': '创建时间',
  },
  '云种植气候': {
    '气候名称': '气候名称',
    '气候图标': '气候图标',
    '封面图': '封面图',
    '气候说明': '气候说明',
    '盲盒种子说明': '盲盒种子说明',
    '状态': '状态',
    '排序': '排序',
    '备注': '备注',
    '创建时间': '创建时间',
  },
  '云种植种子': {
    '种子名称': '种子名称',
    '种子图片': '种子图片',
    '种子描述': '种子描述',
    '生长周期': '生长周期(天)',
    '所属气候': '所属气候',
    '种子价格': '种子价格',
    '温馨提示': '温馨提示',
    '状态': '状态',
    '排序': '排序',
    '备注': '备注',
    '创建时间': '创建时间',
  },
  '云种植监控': {
    '设备号': '设备号',
    '所属气候': '所属气候',
    '位置名称': '位置名称',
    '拉流地址': '拉流地址',
    '状态': '状态',
    '排序': '排序',
    '备注': '备注',
    '创建时间': '创建时间',
  },
  '土地管理': {
    '土地名称': '土地名称',
    '土地图片': '土地图片',
    '气候': '气候',
    '监控配置': '监控配置',
    '面积': '面积(㎡)',
    '状态': '状态',
    '排序': '排序',
    '备注': '备注',
    '创建时间': '创建时间',
  },
  '土地面积价格': {
    '面积': '面积(㎡)',
    '价格': '价格(元)',
    '状态': '状态',
    '排序': '排序',
    '备注': '备注',
    '创建时间': '创建时间',
  },
  '土地时效价格': {
    '时长': '时长(天)',
    '价格': '价格(元)',
    '状态': '状态',
    '排序': '排序',
    '备注': '备注',
    '创建时间': '创建时间',
  },
  '监控时效价格': {
    '时长': '时长(天)',
    '价格': '价格(元)',
    '状态': '状态',
    '排序': '排序',
    '备注': '备注',
    '创建时间': '创建时间',
  },
  '操作价格': {
    '操作名称': '操作名称',
    '操作图标': '操作图标',
    '价格': '价格(元)',
    '状态': '状态',
    '排序': '排序',
    '备注': '备注',
    '创建时间': '创建时间',
  },
  '操作次数': {
    '土地': '土地',
    '操作': '操作',
    '总次数': '总次数',
    '剩余次数': '剩余次数',
    '创建时间': '创建时间',
  },
  '操作记录': {
    '土地': '土地',
    '操作': '操作',
    '操作时间': '操作时间',
    '备注': '备注',
    '创建时间': '创建时间',
  },
  '种植记录': {
    '土地': '土地',
    '种子': '种子',
    '种植时间': '种植时间',
    '状态': '状态',
    '备注': '备注',
    '创建时间': '创建时间',
  },
  '邮寄申请': {
    '用户': '用户',
    '种子': '种子',
    '气候': '气候',
    '申请状态': '申请状态',
    '申请时间': '申请时间',
    '审核时间': '审核时间',
    '审核备注': '审核备注',
    '发货状态': '发货状态',
    '发货时间': '发货时间',
    '物流单号': '物流单号',
    '创建时间': '创建时间',
  },
  '种子仓库': {
    '用户': '用户',
    '种子': '种子',
    '土地': '土地',
    '平台确认': '平台确认',
    '已确认': '已确认',
    '未确认': '未确认',
    '是否已种植': '是否已种植',
    '已种植': '已种植',
    '未种植': '未种植',
    '状态': '状态',
    '获得时间': '获得时间',
    '创建时间': '创建时间',
  },
  '平台地址': {
    '联系人': '联系人',
    '联系电话': '联系电话',
    '省份': '省份',
    '城市': '城市',
    '区县': '区县',
    '详细地址': '详细地址',
    '状态': '状态',
    '排序': '排序',
    '备注': '备注',
    '创建时间': '创建时间',
  },
  '抽奖活动奖池配置':{
    'id':'id',
    '名称':'名称',
    '图片':'图片',
    '奖励类型':'奖励类型',
    '奖励金额':'奖励金额',
    '中奖概率':'中奖概率',
    '描述':'描述',
    '创建者':'创建者',
    '创建时间':'创建时间',
    '修改人':'修改人',
    '更新时间':'更新时间',
    '逻辑删除标记':'逻辑删除标记',
    '租户ID，外键{tenant.id}':'租户ID，外键{tenant.id}',
    '备注':'备注',
    '版本号':'版本号',
    '排序':'排序',
    '优惠券':'优惠券',
    '中奖概率之和不能超过100':'中奖概率之和不能超过100%，当前已配置{sum}%，本次配置{current}%',
  },
  '抽奖活动中奖记录':{
    'id':'id',
    '抽奖活动id':'抽奖活动id',
    '中奖信息文案':'中奖信息文案',
    '奖励类型':'奖励类型',
    '奖励金额':'奖励金额',
    '商品id':'商品id',
    '商品名称':'商品名称',
    '商品图片':'商品图片',
    '邮寄状态':'邮寄状态',
    '申请邮寄地址':'申请邮寄地址',
    '姓名':'姓名',
    '手机号':'手机号',
    '发货方式':'发货方式',
    '详细地址':'详细地址',
    '物流公司id':'物流公司id',
    '物流公司名称':'物流公司名称',
    '寄件人手机号':'寄件人手机号',
    '物流编号':'物流编号',
    '优惠券id':'优惠券id',
    '优惠券名称':'优惠券名称',
    '创建者':'创建者',
    '创建时间':'创建时间',
    '修改人':'修改人',
    '更新时间':'更新时间',
    '逻辑删除标记':'逻辑删除标记',
    '租户ID':'租户ID',
    '备注':'备注',
    '版本号':'版本号',
    '抽奖详情':'抽奖详情',
    '抽奖信息':'抽奖信息',
    '抽奖人昵称':'抽奖人昵称',
    '抽奖人手机号':'抽奖人手机号',
    '抽奖人头像':'抽奖人头像',
  },
  '审核状态':{
    '待审核':'待审核',
    '审核失败':'审核失败',
    '审核成功':'审核成功',
    '过期未审核':'过期未审核',
    '活动已结束':'活动已结束',
  },
  '奖励类型':{
    '谢谢惠顾':'谢谢惠顾',
    '平台币':'平台币',
    '商品':'商品',
    '优惠券':'优惠券',
  },
  '邮寄状态':{
    '待申请邮寄':'待申请邮寄',
    '待邮寄':'待邮寄',
    '已邮寄':'已邮寄',
  },
  '用户角色类型':{
    '平台':'平台',
    '商户':'商户',
    '店长':'店长',
    '店员':'店员',
    '用户':'用户',
    '供应商':'供应商',
  },
  '特价活动商品':{
    '主键id':'主键id',
    '店铺id':'店铺id',
    '商品id':'商品id',
    '活动名称':'活动名称',
    '商品名称':'商品名称',
    '特价价格':'特价价格',
    '原价':'原价',
    '商品图片':'商品图片',
    '状态':'状态',
    '拒绝原因':'拒绝原因',
    '创建者':'创建者',
    '创建时间':'创建时间',
    '修改人':'修改人',
    '更新时间':'更新时间',
    '逻辑删除标记':'逻辑删除标记',
    '租户ID，外键{tenant.id}':'租户ID，外键{tenant.id}',
    '备注':'备注',
    '版本号':'版本号',
    'SKU特价设置':'SKU特价设置',
    'SKU名称':'SKU名称',
    'SKU图片':'SKU图片',
    '库存':'库存',
    '特价':'特价',
  },
  '上门服务公告': {
    '公告标题': '公告标题',
    '公告简介': '公告简介',
    '公告内容': '公告内容',
    '分类': '分类',
    '用户端': '用户端',
    '师傅端': '师傅端',
    '排序': '排序',
    '排序提示': '数字越大越靠前',
    '备注': '备注',
    '创建时间': '创建时间',
  },
  '上门服务分类': {
    '分类名称': '分类名称',
    '父级分类': '父级分类',
    '分类级别': '分类级别',
    '一级分类': '一级分类',
    '二级分类': '二级分类',
    '分类图标': '分类图标',
    '是否首页展示': '是否首页展示',
    '排序': '排序',
    '排序提示': '数字越大越靠前',
    '备注': '备注',
    '创建时间': '创建时间',
    '添加子分类': '添加子分类',
    '新增一级分类': '新增一级分类',
    '新增二级分类': '新增二级分类',
    '修改分类': '修改分类',
    '确认删除分类': '确认删除该分类？',
  },
  '上门服务': {
    '服务名称': '服务名称',
    '服务简介': '服务简介',
    '服务编号': '服务编号',
    '服务主图': '服务主图',
    '归属城市': '归属城市',
    '归属城市提示': '可多选城市，不选默认全国',
    '全国': '全国',
    '服务轮播图': '服务轮播图',
    '服务详情': '服务详情',
    '服务价格': '服务价格',
    '价格单位': '价格单位',
    '服务分类': '服务分类',
    '是否推荐': '是否推荐',
    '是否热搜': '是否热搜',
    '状态': '状态',
    '排序': '排序',
    '备注': '备注',
    '创建时间': '创建时间',
    '服务项目': '服务项目',
    '添加项目': '添加项目',
    '项目名称': '项目名称',
    '项目价格': '项目价格',
    '服务项目至少一条': '服务项目至少应添加一条数据',
    '服务': '服务',
    '选择服务': '选择服务',
  },
  '商城头条': {
    '标题': '标题',
    '封面图': '封面图',
    '富文本详情': '富文本详情',
    '发布时间': '发布时间',
    '是否首页展示': '是否首页展示',
    '排序': '排序',
    '所属分类': '所属分类',
    '备注': '备注',
    '创建时间': '创建时间',
  },
  '废品服务': {
    '扔垃圾服务配置': '扔垃圾服务配置',
    '收废品服务配置': '收废品服务配置',
    '服务名称': '服务名称',
    '服务说明': '服务说明',
    '服务封面图': '服务封面图',
    '服务价格': '服务价格',
    '服务介绍': '服务介绍',
    '服务标准': '服务标准',
    '备注': '备注',
  },
  '技能管理': {
    '技能名称': '技能名称',
    '技能图标': '技能图标',
    '技能类型': '技能类型',
    '通用技能': '通用技能',
    '废品技能': '废品技能',
    '排序': '排序',
    '状态': '状态',
    '备注': '备注',
    '新增技能': '新增技能',
    '修改技能': '修改技能',
    '创建时间': '创建时间',
  },
  '入驻审核': {
    '角色类型': '角色类型',
    '头像': '头像',
    '姓名': '姓名',
    '联系方式': '联系方式',
    '地区': '地区',
    '角色照片': '角色照片',
    '审核状态': '审核状态',
    '保证金状态': '保证金状态',
    '工作状态': '工作状态',
    '创建时间': '创建时间',
    '详情': '详情',
    'APP用户手机号': 'APP用户手机号',
    'APP用户昵称': 'APP用户昵称',
    '地址': '地址',
    '身份证号码': '身份证号码',
    '从业时间': '从业时间',
    '身份证人面像': '身份证人面像',
    '身份证国徽面': '身份证国徽面',
    '手持身份证': '手持身份证',
    '已缴纳保证金': '已缴纳保证金',
    '账户余额': '账户余额',
    '服务评价': '服务评价',
    '接单数量': '接单数量',
    '后台账号ID': '后台账号ID',
    '后台账号名': '后台账号名',
    '社区审核列表': '社区审核列表',
    '审核备注': '审核备注',
    '审核时间': '审核时间',
    '审核结果': '审核结果',
    '审核详情': '审核详情',
    '真实姓名': '真实姓名',
    '申请时间': '申请时间',
    '详细地址': '详细地址',
    '社区名称': '社区名称',
    '工装头像/大门照': '工装头像/大门照',
    '个人介绍': '个人介绍',
    '用户信息': '用户信息',
    '用户信息搜索提示': '可搜索昵称或手机号',
    '昵称': '昵称',
    '手机号': '手机号',
    '通过': '通过',
    '拒绝': '拒绝',
    '备注': '备注',
    '修改审核': '修改审核',
    '请选择审核结果': '请选择审核结果',
    '请输入审核备注': '请输入审核备注',
    '请输入拒绝原因': '请输入拒绝原因',
  },
  '敏感内容日志': {
    '用户ID': '用户ID',
    '用户信息': '用户信息',
    '用户信息搜索提示': '可搜索昵称或手机号',
    '用户IP': '用户IP',
    '命中类型': '命中类型',
    '文本': '文本',
    '图片': '图片',
    '业务场景': '业务场景',
    '敏感内容': '敏感内容',
    '敏感文字内容': '敏感文字内容',
    '违规图片': '违规图片',
    '查看违规图片': '查看违规图片',
    '图片预览': '图片预览',
    '昵称': '昵称',
    '手机号': '手机号',
    '创建时间': '创建时间',
    '日志详情': '日志详情',
  },
  '社区账单': {
    '社区名称': '社区名称',
    '用户信息': '用户信息',
    '用户信息搜索提示': '可搜索昵称或手机号',
    '用户昵称': '用户昵称',
    '手机号': '手机号',
    '房间号': '房间号',
    '账单类型': '账单类型',
    '账单年月': '账单年月',
    '账单金额': '账单金额',
    '支付状态': '支付状态',
    '创建时间': '创建时间',
    '选择社区': '选择社区',
    '选择业主房号': '选择业主房号',
    '选择房间': '选择房间',
    '水费': '水费',
    '水费金额': '水费金额',
    '水费账单图片': '水费账单图片',
    '电费': '电费',
    '电费金额': '电费金额',
    '电费账单图片': '电费账单图片',
    '燃气费': '燃气费',
    '燃气费金额': '燃气费金额',
    '燃气费账单图片': '燃气费账单图片',
    '物业费': '物业费',
    '物业费每月': '物业费每月',
    '缴纳月数': '缴纳月数',
    '账单总金额': '账单总金额',
    '备注': '备注',
    '请选择房间': '该用户有房间，请选择房间',
    '用户无房间': '该用户没有房间，无法提交账单',
  },
  '服务订单': {
    '服务订单': '服务订单',
    '订单编号': '订单编号',
    '订单类型': '订单类型',
    '服务类型': '服务类型',
    '订单状态': '订单状态',
    '服务主图': '服务主图',
    '服务名称': '服务名称',
    '服务项目名称': '服务项目名称',
    '联系人姓名': '联系人姓名',
    '联系人电话': '联系人电话',
    '服务完成备注': '服务完成备注',
    '实付金额': '实付金额',
    '优惠金额': '优惠金额',
    '订单原价': '订单原价',
    '加价状态': '加价状态',
    '有加价': '有加价',
    '用户信息': '用户信息',
    '用户信息搜索提示': '可搜索昵称或手机号',
    '预约时间': '预约时间',
    '预约服务时间': '预约服务时间',
    '创建时间': '创建时间',
    '订单详情': '订单详情',
    '基本信息': '基本信息',
    '服务信息': '服务信息',
    '用户信息': '用户信息',
    '接单方信息': '接单方信息',
    '加价信息': '加价信息',
    '完成信息': '完成信息',
    '评价信息': '评价信息',
    '取消信息': '取消信息',
    '金额信息': '金额信息',
    '支付方式': '支付方式',
    '支付时间': '支付时间',
    '是否使用优惠券': '是否使用优惠券',
    '是': '是',
    '否': '否',
    '优惠券名称': '优惠券名称',
    '用户昵称': '用户昵称',
    '用户手机号': '用户手机号',
    '服务地址': '服务地址',
    '服务房间号': '服务房间号',
    '服务业主名': '服务业主名',
    '服务业主电话': '服务业主电话',
    '用户备注': '用户备注',
    '用户备注图片': '用户备注图片',
    '接单方类型': '接单方类型',
    '接单方名称': '接单方名称',
    '接单方头像': '接单方头像',
    '接单方电话': '接单方电话',
    '接单方星级': '接单方星级',
    '接单时间': '接单时间',
    '开始上门时间': '开始上门时间',
    '加价金额': '加价金额',
    '加价备注': '加价备注',
    '加价图片': '加价图片',
    '完成时间': '完成时间',
    '服务完成图片': '服务完成图片',
    '评价星级': '评价星级',
    '评价时间': '评价时间',
    '评价内容': '评价内容',
    '取消方': '取消方',
    '取消时间': '取消时间',
    '取消原因': '取消原因',
    '指定师傅': '指定师傅',
    '选择师傅': '选择师傅',
    '接单量': '接单量',
    '请选择师傅': '请选择师傅',
    '上门服务': '上门服务',
    '废品服务': '废品服务',
    '扔垃圾': '扔垃圾',
    '收废品': '收废品',
    '待支付': '待支付',
    '待接单': '待接单',
    '待服务': '待服务',
    '服务中': '服务中',
    '已完成': '已完成',
    '已取消': '已取消',
    '服务订单': '服务订单',
  },
  '空间': {
    '空间名称': '空间名称',
    '封面图': '封面图',
    '空间主图': '空间主图',
    '是否免费': '是否免费',
    '免费': '免费',
    '收费': '收费',
    '购买价钱': '购买价钱',
    '空间描述': '空间描述',
    '状态': '状态',
    '启用': '启用',
    '禁用': '禁用',
    '排序': '排序',
    '基础信息': '基础信息',
    '空间门管理': '空间门管理',
    '请上传': '请上传',
    '云种植': '云种植',
    '商城': '商城',
    '直播社区': '直播社区',
    '短剧': '短剧',
    '需要服务': '需要服务',
    '提供服务': '提供服务',
    '商家维护': '商家维护',
    '平台维护': '平台维护',
    '门类型': '门类型',
    '门图片': '门图片',
    '创建时间': '创建时间',
    '备注': '备注',
  },
  '师傅提现': {
    '主键id': '主键id',
    '用户ID': '用户ID',
    '店铺ID': '店铺ID',
    '师傅信息': '师傅信息',
    '师傅昵称': '师傅昵称',
    '师傅手机号': '师傅手机号',
    '提现金额': '提现金额',
    '提现手续费': '提现手续费',
    '审核状态': '审核状态',
    '未审核': '未审核',
    '审核未通过': '审核未通过',
    '审核已通过': '审核已通过',
    '转账中': '转账中',
    '已转账': '已转账',
    '提现账号': '提现账号',
    '提现账号（支付账号或微信openId或者银行卡号）': '提现账号（支付账号或微信openId或者银行卡号）',
    '提现账号姓名': '提现账号姓名',
    '提现方式': '提现方式',
    '支付宝': '支付宝',
    '微信': '微信',
    '银行卡': '银行卡',
    '提现场景': '提现场景',
    '线上自动打款': '线上自动打款',
    '线下手动打款': '线下手动打款',
    '用户收款码': '用户收款码',
    '第三方订单号': '第三方订单号',
    '第三方订单号(微信或支付的交易单号)': '第三方订单号(微信或支付的交易单号)',
    '失败原因': '失败原因',
    '审核意见': '审核意见',
    '审核通过': '审核通过',
    '审核拒绝': '审核拒绝',
    '请填写审核意见': '审核拒绝时请填写审核意见',
    '创建时间': '创建时间',
    '修改时间': '修改时间',
    '创建人': '创建人',
    '修改人': '修改人',
    '备注': '备注',
  },
  '常见问题解决状态': {
    '用户信息': '用户信息',
    '用户信息搜索提示': '可搜索昵称或手机号',
    '问题标题': '问题标题',
    '昵称': '昵称',
    '手机号': '手机号',
    '解决状态': '解决状态',
    '未解决原因': '未解决原因',
    '创建时间': '创建时间',
  },
  '视频评价': {
    '视频编号': '视频编号',
    '被评价用户': '被评价用户',
    '评价用户': '评价用户',
    '昵称': '昵称',
    '手机号': '手机号',
    '评价内容': '评价内容',
    '评价状态': '评价状态',
    '回复数量': '回复数量',
    '审核通过': '审核通过',
    '审核未通过': '审核未通过'
  },
  '查看评论': '查看评论',
  '实名认证状态': '实名认证状态',
  '未认证': '未认证',
  '已认证': '已认证',
  '审核中': '审核中',
  '审核驳回': '审核驳回',
  '提交审核时间': '提交审核时间',
  '云种植订单': {
    '云种植订单': '云种植订单',
    '订单编号': '订单编号',
    '用户信息': '用户信息',
    '用户信息搜索提示': '可搜索昵称或手机号',
    '昵称': '昵称',
    '手机号': '手机号',
    '订单类型': '订单类型',
    '支付状态': '支付状态',
    '数量': '数量',
    '面积': '面积',
    '时长': '时长(天)',
    '单价': '单价',
    '实付金额': '实付金额',
    '支付时间': '支付时间',
    '创建时间': '创建时间',
    '待支付': '待支付',
    '已支付': '已支付',
    '已取消': '已取消',
    '购买种子': '购买种子',
    '购买土地': '购买土地',
    '土地续费': '土地续费',
    '购买监控': '购买监控',
    '监控续费': '监控续费',
    '购买操作次数': '购买操作次数'
  },
  '空间订单': {
    '空间订单': '空间订单',
    '订单编号': '订单编号',
    '用户信息': '用户信息',
    '用户信息搜索提示': '可搜索昵称或手机号',
    '昵称': '昵称',
    '手机号': '手机号',
    '空间名称': '空间名称',
    '订单金额': '订单金额',
    '实付金额': '实付金额',
    '支付状态': '支付状态',
    '支付时间': '支付时间',
    '取消时间': '取消时间',
    '取消原因': '取消原因',
    '创建时间': '创建时间',
    '待支付': '待支付',
    '已支付': '已支付',
    '已取消': '已取消'
  },
  '保证金订单': {
    '保证金订单': '保证金订单',
    '订单编号': '订单编号',
    '用户信息': '用户信息',
    '用户信息搜索提示': '可搜索昵称或手机号',
    '昵称': '昵称',
    '手机号': '手机号',
    '师傅名称': '师傅名称',
    '订单类型': '订单类型',
    '保证金金额': '保证金金额',
    '支付状态': '支付状态',
    '支付时间': '支付时间',
    '退款状态': '退款状态',
    '退款时间': '退款时间',
    '退款理由': '退款理由',
    '创建时间': '创建时间',
    '待支付': '待支付',
    '已支付': '已支付',
    '已取消': '已取消',
    '未退款': '未退款',
    '退款中': '退款中',
    '已退款': '已退款',
    '缴纳保证金': '缴纳保证金',
    '退回保证金': '退回保证金'
  }
}
